<app-contribution-setup [config]="config">
  <app-org-admin-sidebar></app-org-admin-sidebar>
</app-contribution-setup>
